module.exports = __webpack_public_path__ + "static/media/zoneOff.d1646907.svg";